/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { EvaluationRule } from '../model/evaluationRule';
import { InlineResponse200 } from '../model/inlineResponse200';
import { MultipleChildResult } from '../model/multipleChildResult';
import { PaginatedMultipleChildResultList } from '../model/paginatedMultipleChildResultList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TeacherResultsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Return general rule that is used to evaluate child&#x27;s result.
     * @param dataSetUuid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherResultsEvaluationGeneralRuleRetrieve(dataSetUuid: string, observe?: 'body', reportProgress?: boolean): Observable<EvaluationRule>;
    public teacherResultsEvaluationGeneralRuleRetrieve(dataSetUuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EvaluationRule>>;
    public teacherResultsEvaluationGeneralRuleRetrieve(dataSetUuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EvaluationRule>>;
    public teacherResultsEvaluationGeneralRuleRetrieve(dataSetUuid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (dataSetUuid === null || dataSetUuid === undefined) {
            throw new Error('Required parameter dataSetUuid was null or undefined when calling teacherResultsEvaluationGeneralRuleRetrieve.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<EvaluationRule>('get',`${this.basePath}/teacher-results/${encodeURIComponent(String(dataSetUuid))}/evaluation-general-rule/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Return all results for teacher.
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param source * &#x60;dad_test&#x60; - Dad Test * &#x60;dad_test_z&#x60; - Dad Test Z * &#x60;questionnaire&#x60; - Questionnaire * &#x60;game&#x60; - Game * &#x60;smart&#x60; - Smart * &#x60;pap_questionnaire&#x60; - Pap Questionnaire
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherResultsList(limit?: number, offset?: number, source?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedMultipleChildResultList>;
    public teacherResultsList(limit?: number, offset?: number, source?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedMultipleChildResultList>>;
    public teacherResultsList(limit?: number, offset?: number, source?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedMultipleChildResultList>>;
    public teacherResultsList(limit?: number, offset?: number, source?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (source !== undefined && source !== null) {
            queryParameters = queryParameters.set('source', <any>source);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedMultipleChildResultList>('get',`${this.basePath}/teacher-results/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Naming of this EP is messy...
     * @param dataSetUuid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherResultsRetrieve(dataSetUuid: string, observe?: 'body', reportProgress?: boolean): Observable<MultipleChildResult>;
    public teacherResultsRetrieve(dataSetUuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MultipleChildResult>>;
    public teacherResultsRetrieve(dataSetUuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MultipleChildResult>>;
    public teacherResultsRetrieve(dataSetUuid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (dataSetUuid === null || dataSetUuid === undefined) {
            throw new Error('Required parameter dataSetUuid was null or undefined when calling teacherResultsRetrieve.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MultipleChildResult>('get',`${this.basePath}/teacher-results/${encodeURIComponent(String(dataSetUuid))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Toggle visibility of a result to managers
     * @param dataSetUuid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherResultsToggleShareWithManagerCreate(dataSetUuid: string, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse200>;
    public teacherResultsToggleShareWithManagerCreate(dataSetUuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse200>>;
    public teacherResultsToggleShareWithManagerCreate(dataSetUuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse200>>;
    public teacherResultsToggleShareWithManagerCreate(dataSetUuid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (dataSetUuid === null || dataSetUuid === undefined) {
            throw new Error('Required parameter dataSetUuid was null or undefined when calling teacherResultsToggleShareWithManagerCreate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InlineResponse200>('post',`${this.basePath}/teacher-results/${encodeURIComponent(String(dataSetUuid))}/toggle-share-with-manager/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
